import React from "react";
import Modal from "../Modal";

// VIBRANT difficulty colors
const DIFFICULTY_LEVELS = [
    { color: "#FDE047", textColor: "#713F12", label: "Straightforward", emoji: "🟨" },
    { color: "#4ADE80", textColor: "#14532D", label: "Medium", emoji: "🟩" },
    { color: "#60A5FA", textColor: "#1E3A8A", label: "Hard", emoji: "🟦" },
    { color: "#C084FC", textColor: "#581C87", label: "Tricky", emoji: "🟪" },
];

function HowToPlayModal({ isOpen, onClose }) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="HOW TO PLAY"
        >
            <div className="space-y-4">
                {/* Main instructions */}
                <div className="space-y-2">
                    <p className="text-sm leading-relaxed text-slate-600">
                        Find groups of four items that share something in common.
                    </p>
                    <ul className="space-y-1 text-sm text-slate-600">
                        <li className="flex items-start gap-2">
                            <span className="text-slate-400 mt-1">•</span>
                            <span>Select four items and tap <strong>Submit</strong> to check your guess.</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="text-slate-400 mt-1">•</span>
                            <span>Find all four groups without making 4 mistakes!</span>
                        </li>
                    </ul>
                </div>

                {/* Difficulty explanation */}
                <div className="border-t border-slate-200 pt-4 space-y-2">
                    <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">
                        Category Difficulty
                    </p>
                    <div className="grid gap-2">
                        {DIFFICULTY_LEVELS.map((level) => (
                            <div
                                key={level.label}
                                className="flex items-center gap-3 p-2.5 rounded-lg"
                                style={{
                                    backgroundColor: level.color,
                                    color: level.textColor
                                }}
                            >
                                <span className="text-lg">{level.emoji}</span>
                                <span className="font-semibold text-sm">{level.label}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Tips */}
                <div className="border-t border-slate-200 pt-4 space-y-2">
                    <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">Tips</p>
                    <ul className="space-y-1 text-sm text-slate-600">
                        <li className="flex items-start gap-2">
                            <span className="text-slate-400 mt-1">•</span>
                            <span>Categories are always more specific than "5-letter words."</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="text-slate-400 mt-1">•</span>
                            <span>Use <strong>Shuffle</strong> if you're stuck!</span>
                        </li>
                    </ul>
                </div>

                {/* Daily puzzle message */}
                <div className="border-t border-slate-200 pt-4">
                    <p className="text-center text-sm font-semibold text-[#38B6FF]">
                        A new puzzle is available each day!
                    </p>
                </div>
            </div>
        </Modal>
    );
}

export default HowToPlayModal;
